import PieChart from 'components/charts/PieChart';
import Card from 'components/card';
import { useEffect, useState } from 'react';

const BASE_OPTIONS = {
    chart: { width: '200px' },
    states: { hover: { filter: { type: 'none' } } },
    legend: { show: true, position: 'bottom' as const },
    dataLabels: { enabled: false },
    plotOptions: {
        donut: {
            expandOnClick: false,
            donut: { labels: { show: true } },
        },
    },
    tooltip: {
        enabled: true,
        theme: 'dark',
        y: {
            formatter: (val: any) => `${val} €`,
        },
    },
};

const PieChartCard = (props: { data: any }) => {
    const { data } = props;

    const [isLoaded, setIsLoaded] = useState(false);
    const [pieChartOptions, setPieChartOptions] = useState({
        ...BASE_OPTIONS,
        labels: [] as string[],
    });
    const [pieChartData, setPieChartData] = useState<number[]>([]);

    useEffect(() => {
        if (!data) return;
        const labels = Object.keys(data).slice(0, 5);
        const values: number[] = Object.values<number>(data).slice(0, 5);
        setPieChartOptions({ ...BASE_OPTIONS, labels });
        setPieChartData(values);
        setIsLoaded(true);
    }, [data]);

    const isEmpty = !data || Object.keys(data).length === 0;

    return (
        <Card extra="rounded-[20px] p-3 border h-full">
            <div className="flex flex-row justify-between px-3 pt-2">
                <div>
                    <div className="text-lg font-bold text-navy-700 dark:text-white">
                        Répartition par clients
                    </div>
                    <p className="text-xs text-gray-400">Top 5 débiteurs</p>
                </div>
            </div>

            <div className="mt-4 mb-auto flex h-[250px] w-full items-center justify-center">
                {isEmpty && (
                    <div className="flex flex-col items-center gap-2 animate-fadeIn">
                        <div className="h-24 w-24 rounded-full bg-gray-100 dark:bg-navy-700" />
                        <p className="text-sm text-gray-400">Aucune donnée disponible</p>
                    </div>
                )}
                {isLoaded && !isEmpty && (
                    <PieChart
                        chartOptions={pieChartOptions}
                        chartData={pieChartData}
                    />
                )}
                {!isLoaded && !isEmpty && (
                    <div className="flex flex-col items-center gap-3 animate-pulse">
                        <div className="h-36 w-36 rounded-full bg-gray-100 dark:bg-navy-700" />
                        <div className="h-3 w-32 rounded bg-gray-100 dark:bg-navy-700" />
                    </div>
                )}
            </div>
        </Card>
    );
};

export default PieChartCard;
